export enum ChartAxisTypes {
    DIMENSION = 'DIMENSION',
    MEASURE = 'MEASURE',
    UNAGGREGATED = 'UNAGGREGATED'
}
